import React from 'react'
import TextField from './../../../baseApp/shared/components/fields/textField/TextField';
import {I18n} from 'react-redux-i18n';
import Alert from "../../../baseApp/shared/components/alerts/Alert";
import FormButtons from "../../../baseApp/shared/components/others/formButtons/FormButtons";
import DataTable from "../../../baseApp/shared/components/table/DataTable";
import PropTypes from "prop-types";
import FormDivider from "../../../baseApp/shared/components/others/Divider";
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';

const VisitorsForm = ({
      visitorFormData: {
          name,
          email,
          companyName,
          mobilePhone,
      },
      alert,
      editMode,
      viewMode,
      handleFieldChange,
      handleOnFieldBlur,
      handleSubmitClick,
      handleBackClick,
      handleEditClick,
      data = [],
      pageSize,
  }) => {

    const columns = [{
        Header: I18n.t("visits.list.date"),
        accessor: "checkInDate",
    }, {
        Header: I18n.t("visits.list.checkInOut"),
        accessor: "checkInOutTime",
    }, {
        Header: I18n.t("visits.list.building"),
        id: "building",
        accessor: visit => visit.entity.name
    }];

    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            <div className="header">
                {buildHeader(editMode, viewMode)}
            </div>
            <div className="fields">
                <div id="user-fields-1" className="row">
                    <TextField
                        value={name.value}
                        label={I18n.t("visitors.form.name.label")}
                        handleFieldChange={value => handleFieldChange("name", value)}
                        handleFieldBlur={() => handleOnFieldBlur("name")}
                        themeName="form"
                        error={name.error}
                        disabled={viewMode}
                        width={4}
                    />
                    <TextField
                        value={email.value}
                        label={I18n.t("visitors.form.email.label")}
                        handleFieldChange={value => handleFieldChange("email", value)}
                        handleFieldBlur={() => handleOnFieldBlur("email")}
                        themeName="form"
                        error={email.error}
                        disabled={viewMode}
                        width={4}
                    />
                </div>
                <div id="user-fields-2" className="row">
                    <TextField
                        value={companyName.value}
                        label={I18n.t("visitors.form.company.label")}
                        handleFieldChange={value => handleFieldChange("companyName", value)}
                        handleFieldBlur={() => handleOnFieldBlur("companyName")}
                        themeName="form"
                        error={companyName.error}
                        disabled={viewMode}
                        width={4}
                    />
                    <TextField
                        value={mobilePhone.value}
                        label={I18n.t("visitors.form.mobilePhone.label")}
                        handleFieldChange={value => handleFieldChange("mobilePhone", value)}
                        handleFieldBlur={() => handleOnFieldBlur("mobilePhone")}
                        themeName="form"
                        error={mobilePhone.error}
                        disabled={viewMode}
                        width={4}
                    />
                </div>
                {!editMode &&
                    <div id="user-fields-3"  >
                        <FormDivider />
                        <div className="table-title">
                            {I18n.t('visitors.form.headers.lastVisits')}
                        </div>
                        <div className="table">
                            <DataTable
                                hasHeader={false}
                                //State dependent
                                data={data}
                                //Pagination
                                pageSize={pageSize}
                                //State independent / Configuration
                                columns={columns}
                                rowIsClickable={false}
                            />
                        </div>
                    </div>}
            </div>
            {editMode &&
                <div className="buttons">
                    <button
                        className=" mt-3 btn btn-primary"
                        onClick={handleSubmitClick}
                    >
                        {I18n.t("forms.save")}
                    </button>
                </div>}
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                hasDelete={false}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                appModule={appModules.VISITOR}
            />
        </div>
    </div>
};

function buildHeader(editMode) {
    return editMode ?
        I18n.t("visitors.form.headers.edit") :
        I18n.t("visitors.form.headers.view");
}

VisitorsForm.propTypes = {
    data: PropTypes.array,
};

export default VisitorsForm;